<div class="mb-3">
  <h1 class="fs-5 fw-bold mb-0">ROI statistics</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-8">
        <app-date-range-selector [date]="'this-month'" [zone]="'Europe/Paris'"></app-date-range-selector>
      </div>

      <div class="col-1">
        <label for="timeCutout" class="form-label fw-bold small">Time Cutout</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-hourglass-split"></i></span>
          <select id="timeCutout" class="form-select" [(ngModel)]="filters.timeCutout">
            @for (timeCutout of timeCutoutList; track timeCutout) {
              <option [ngValue]="timeCutout.key">{{ timeCutout.label }}</option>
            }
          </select>
        </div>
      </div>

      <div class="col-3">
        <label for="dataShown" class="form-label fw-bold small">Data Shown</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
          <select id="dataShown" class="form-select" [(ngModel)]="filters.dataType">
            @for (dataType of dataTypeList; track dataType) {
              <option [ngValue]="dataType.key">{{ dataType.label }}</option>
            }
          </select>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-3">
        <label class="form-label fw-bold small">Brand</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-box"></i></span>
          <select class="form-select" [(ngModel)]="filters.product" (ngModelChange)="changeProduct()">
            <option [ngValue]="null">{{ getProductPlaceholder() }}</option>
            @for (product of products; track product) {
              <option [ngValue]="product"> {{ product.name }}</option>
            }
          </select>
        </div>
      </div>

      <div class="col-3">
        <label class="form-label fw-bold small">Offer</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-basket"></i></span>
          <select class="form-select" [(ngModel)]="filters.offer" [appElementLoader]="offerLoading"
            (ngModelChange)="changeOffer()">
            <option [ngValue]="null">{{ getOfferPlaceholder() }}</option>
            @for (offer of offers; track offer) {
              <option [ngValue]="offer">{{ offer.name }}</option>
            }
          </select>
        </div>
      </div>

      <div class="col-3">
        <label class="form-label fw-bold small">Promotion link</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-window"></i></span>
          <select class="form-select landing-page-activity" [(ngModel)]="filters.landingPageActivity"
            (ngModelChange)="refreshLandingPages()" title="Only promotion links with at least 1 click since…">
            <option [ngValue]="null">Activity</option>
            @for (period of activityPeriods; track period.identifier) {
              <option [ngValue]="period.identifier">{{ period.shortLabel }}</option>
            }
          </select>
          <select class="form-select" [(ngModel)]="filters.landingPage"
            [appElementLoader]="landingPageLoading">
            <option [ngValue]="null">{{ getLandingPagePlaceholder() }}</option>
            @for (landingPage of landingPages; track landingPage) {
              <option
                [ngValue]="landingPage">{{ landingPage.name }}
              </option>
            }
          </select>
        </div>
      </div>

      <div class="col-3">
        <label class="form-label fw-bold small">Pools</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-window"></i></span>
          <select class="form-select" [(ngModel)]="filters.pool">
            <option [ngValue]="null">{{ getPoolPlaceholder() }}</option>
            @for (pool of pools; track pool) {
              <option
                [ngValue]="pool">{{ pool.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-3">
        <label for="accountType" class="form-label fw-bold small">Account Type</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-people"></i></span>
          <select class="form-select" id="accountType" [(ngModel)]="filters.accountType"
            (ngModelChange)="changeAccountTypeManager()">
            <option [ngValue]="null">All account types</option>
            @for (accountType of partnerAccountTypeList; track accountType) {
              <option
                [ngValue]="accountType">{{ 'partnerAccountType.' + accountType | translate }}
              </option>
            }
          </select>
        </div>
      </div>

      @if (isMediaBuy()) {
        <div class="col-3">
          <label class="form-label">Advertising Platform</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-bar-chart-line"></i></span>
            <select class="form-select" [(ngModel)]="filters.advertisingPlatform"
              (ngModelChange)="changeAdvertisingPlatform()">
              <option [ngValue]="null">All platforms</option>
              @for (advertisingPlatform of advertisingPlatformList; track advertisingPlatform) {
                <option
                  [value]="advertisingPlatform.id">{{ advertisingPlatform.name }}
                </option>
              }
            </select>
          </div>
        </div>
      }

      <div class="col-3">
        <label class="form-label fw-bold small">Account Manager</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-person-circle"></i></span>
          <select class="form-select" [(ngModel)]="filters.accountManager"
            (ngModelChange)="changeAccountManager()">
            <option [ngValue]="null">All account managers</option>
            @for (accountManager of accountManagers; track accountManager) {
              <option
                [ngValue]="accountManager">{{ accountManager }}
              </option>
            }
          </select>
        </div>
      </div>

      <div [ngClass]="{'col-3':isMediaBuy(),'col-6':!isMediaBuy()}">
        <label class="form-label fw-bold small">Partner</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
          <select class="form-select" [(ngModel)]="filters.partner" [appElementLoader]="partnerLoading">
            <option [ngValue]="null">{{ getPartnerPlaceholder() }}</option>
            @for (partner of partners; track partner) {
              <option [ngValue]="partner">{{ partner }}</option>
            }
          </select>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-3">
        <label class="form-label fw-bold small">Language</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-translate"></i></span>
          <app-dropdown-select [(ngModel)]="filters.lang">
            <app-dropdown-select-option [value]="null">All languages</app-dropdown-select-option>
            @for (lang of languages; track lang) {
              <app-dropdown-select-option [value]="lang.isoCode">
                <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name" class="country-flag"
                  width="24" height="24">
                {{ lang.name }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
      </div>

      <div class="col-3">
        <label class="form-label fw-bold small">Country</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-geo-alt"></i></span>
          <app-dropdown-select [(ngModel)]="filters.country">
            <app-dropdown-select-option [value]="null">All countries</app-dropdown-select-option>
            @for (country of countries; track country) {
              <app-dropdown-select-option [value]="country.isoCode">
                <img [ngSrc]="countryService.getFlag(country.isoCode)" [alt]="country.name"
                  class="country-flag"
                  width="24" height="24">
                {{ country.name }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
      </div>

      <div class="col-3">
        <label for="coreg" class="form-label fw-bold small">P2</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-diagram-3"></i></span>
          <select id="coreg" class="form-select" [(ngModel)]="filters.coreg">
            <option [ngValue]="null">All</option>
            <option [ngValue]="0">Without P2</option>
            <option [ngValue]="1">Only P2</option>
          </select>
        </div>
      </div>

      <div class="col-3">
        <label for="ar" class="form-label fw-bold small">Xsell</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-bar-chart"></i></span>
          <select id="ar" class="form-select" [(ngModel)]="filters.cross">
            <option [ngValue]="null">All</option>
            <option [ngValue]="0">Without Xsell</option>
            <option [ngValue]="1">Only Xsell</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col">
        <label class="form-label fw-bold small">SubID</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-filter"></i></span>
          <input type="text" class="form-control" value="" [(ngModel)]="filters.subid">
        </div>
      </div>

      <div class="col">
        <label class="form-label fw-bold small">Tracker 1</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input type="text" class="form-control" value="" [(ngModel)]="filters.tc1">
        </div>
      </div>
      <div class="col">
        <label class="form-label fw-bold small">Tracker 2</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input type="text" class="form-control" value="" [(ngModel)]="filters.tc2">
        </div>
      </div>
      <div class="col">
        <label class="form-label fw-bold small">Tracker 3</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input type="text" class="form-control" value="" [(ngModel)]="filters.tc3">
        </div>
      </div>
      <div class="col">
        <label class="form-label fw-bold small">Tracker 4</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input type="text" class="form-control" value="" [(ngModel)]="filters.tc4">
        </div>
      </div>
      <div class="col">
        <label class="form-label fw-bold small">Source</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input type="text" class="form-control" value="" [(ngModel)]="filters.source">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <label class="form-label fw-bold small">Sequence(s)</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-list-task"></i></span>
          <app-dropdown-select [(ngModel)]="filters.goalTypeNames" [multiple]="true">
            @for (goalTypeName of goalTypeNameList; track goalTypeName) {
              <app-dropdown-select-option
                [value]="goalTypeName.key">
                {{ goalTypeName.label }}
              </app-dropdown-select-option>
            }
          </app-dropdown-select>
        </div>
      </div>

      <div class="offset-3 col-3">
        <label for="groupBy" class="form-label fw-bold small">Group By</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-diagram-2"></i></span>
          <select id="groupBy" class="form-select" [(ngModel)]="filters.groupBy">
            <option value="date-day">Date - by day</option>
            <option value="date-week">Date - by week</option>
            <option value="date-month">Date - by month</option>
            <option value="landingPage">Promotion links</option>
            <option value="partner">Partners</option>
            <option value="offer">Offers</option>
            <option value="country">Countries</option>
            <option value="lang">Languages</option>
            <option value="subid">SubID</option>
            <option value="tc1">Tracker 1</option>
            <option value="tc2">Tracker 2</option>
            <option value="tc3">Tracker 3</option>
            <option value="tc4">Tracker 4</option>
          </select>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 mt-4">
        <div class="row">
          <div class="col-3">
            <!--                        <label class="form-label fw-bold small">Preconfigured Reports</label>-->
            <!--                        <div class="input-group">-->
            <!--                            <span class="input-group-text"><i class="bi bi-save"></i></span>-->
            <!--                            <select class="form-select">-->
            <!--                                <option>Pre</option>-->
          <!--                            </select>-->
          <!--                            <button type="button" class="btn btn-outline-primary fw-bold">Edit</button>-->
          <!--                            <button type="button" class="btn btn-outline-primary fw-bold" data-bs-toggle="modal"-->
          <!--                                    data-bs-target="#saveReportModal">Save-->
        <!--                            </button>-->
        <!--                            <button type="button" class="btn btn-primary fw-bold">Apply</button>-->
      <!--                        </div>-->
    </div>

    <div class="col-9 mt-4 text-end d-flex align-items-end justify-content-end">
      <button type="button" class="btn btn-outline-primary fw-bold me-2" [disabled]="loading || !rows.length"
        (click)="downloadCsv()"><i
      class="bi bi-file-earmark-spreadsheet"></i> Export to CSV
    </button>
    <button type="submit" class="btn btn-primary fw-bold" (click)="filter()">Apply filters</button>
  </div>
</div>
</div>
</div>
</div>
</div>

@if (!loading) {
  <div class="card border-0 shadow mb-3">
    <div class="card-header fw-bold bg-tertiary p-3 border-0">
      <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-file-earmark-spreadsheet me-2"></i>ROI statistics table</h2>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-striped align-middle">
          <thead class="thead-light">
            <tr class="table-light">
              <th colspan="8" class="text-center" style="width:50%;">Acquisition Metrics</th>
              <th [colSpan]="timeDays.length" class="text-center" style="width:50%;">Data Evolution</th>
            </tr>
            <tr class="table-light">
              <th>{{ getGroupByColumnName() }}</th>
              <th>Leads</th>
              <th>Acquisition Leads</th>
              <th>Reactivation</th>
              <th>A/R</th>
              <th>Cost</th>
              <th>Revenue</th>
              <th>CPL</th>
              @for (day of timeDays; track day) {
                <th>{{ day }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row) {
              <tr>
                <td>{{ getLabel(row) }}</td>
                <td>{{ row.leadTotal }}</td>
                <td>{{ row.leadOk }}</td>
                <td>{{ row.leadReactivated }}</td>
                <td>{{ row.leadAR }}</td>
                <td>{{ row.cost | money }}</td>
                <td>{{ row.revenue | money }}</td>
                <td>{{ row.leadCPL | money }}</td>
                @for (day of timeDays; track day; let i = $index) {
                  <td
                    [ngClass]="getHeatmapClass(row, i)">{{ getTimeValue(row, i) }}
                  </td>
                }
              </tr>
            }
            <tr>
              <td class="fw-bold">Total</td>
              <td class="fw-bold">{{ totals.leadTotal }}</td>
              <td class="fw-bold">{{ totals.leadOk }}</td>
              <td class="fw-bold">{{ totals.leadReactivated }}</td>
              <td class="fw-bold">{{ totals.leadAR }}</td>
              <td class="fw-bold">{{ totals.cost | money }}</td>
              <td class="fw-bold">{{ totals.revenue | money }}</td>
              <td class="fw-bold">{{ totals.leadCPL | money }}</td>
              @for (day of timeDays; track day) {
                <td></td>
              }
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
